import { render, staticRenderFns } from "./QuestionInputBox.vue?vue&type=template&id=4da6b89c&scoped=true"
import script from "./QuestionInputBox.vue?vue&type=script&lang=js"
export * from "./QuestionInputBox.vue?vue&type=script&lang=js"
import style0 from "./QuestionInputBox.vue?vue&type=style&index=0&id=4da6b89c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da6b89c",
  null
  
)

export default component.exports